import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ShopArticleTaxHistoriesApi from '../generated/api/ShopArticleTaxHistories';

export default (service: Servicelayer) => ({
  ...ShopArticleTaxHistoriesApi(service),

  // Add custom calls here

});
